import "../assets/styles/listings.css";
import { Link, useNavigate } from "react-router-dom";
import virtualImage from "../assets/images/advertisement/virtual-ad.png";
import dogImage from "../assets/images/advertisement/dog-circle.gif";
import probioticImage from "../assets/images/advertisement/probiotics-ad.png";
import sellImage from "../assets/images/sell.png";
import crateImage from "../assets/images/crate2.png";
import { FiSearch } from "react-icons/fi";
import Logo from "../assets/images/logo/321VETS_LOGO.png";
import { useCategories } from "../hooks/useCategories";
import useUser from "../hooks/useUser";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useEffect, useState } from "react";
function Listings() {
  const [user, setUser] = useState(null);
  const { categories = [], loading, error } = useCategories();
  const { getMe } = useUser();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    getMe(token)
      .then((data) => {
        setUser(data);
      })
      .catch(() => {
        console.log("Error fetching user data");
      });
  }, [token]);

  // Build a tree from flat categories, sorted by priority descending
  const buildCategoryTree = (cats, parentId = null) => {
    return cats
      .filter((cat) => cat.parent_category_id === parentId)
      .sort((a, b) => (b.priority || 0) - (a.priority || 0))
      .map((cat) => ({
        ...cat,
        children: buildCategoryTree(cats, cat.id),
      }));
  };
  const categoryTree = buildCategoryTree(categories);

  // Render each parent and its children as a card, all cards in a grid
  const renderCategoryGrid = () => (
    <div
      className="w-full grid gap-6 my-6"
      style={{
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        display: "grid",
      }}
    >
      {categoryTree.map((parent) => (
        <div
          key={parent.id}
          className="bg-white flex flex-col items-center px-0 py-0 text-center font-['Roboto','Arial',sans-serif] font-semibold"
        >
          <button
            className="w-full bg-[#eeeeee] rounded-t-lg py-3 px-2 text-[1.2rem] font-bold hover:underline focus:outline-none capitalize text-center"
            style={{ color: "black", borderRadius: "0.2em", margin: 0 }}
            onClick={() => navigate(`/listing?category=${parent.id}`)}
            type="button"
          >
            {parent.name}
          </button>
          {parent.children && parent.children.length > 0 && (
            <div className="flex flex-col w-full items-center py-2 px-2 gap-1">
              {parent.children.map((child) => (
                <button
                  key={child.id}
                  className=" underline hover:underline text-[1rem] font-medium py-1 px-2 rounded capitalize text-left"
                  style={{ textDecorationColor: "grey" }}
                  onClick={() => navigate(`/listing?category=${child.id}`)}
                  type="button"
                >
                  {child.name}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div className="listings">
      <div className="location">
        {/* Logo to be displayed on mobile devices only */}
        <div className="mobile-logo">
          {/* <span>321 Vets</span> */}
          <img src={Logo} alt="321 vets" width={70} />
        </div>

        {/* Displays user location */}
        <div className="title">
          <h2>
            {user?.region || user?.city ? (
              <>
                <LocationOnIcon />
                {user?.region},{user?.city}
              </>
            ) : (
              ""
            )}
          </h2>
        </div>
      </div>

      {/* Search input for mobile */}
      {/* <div className="input-container">
        <input className="mobile-input" placeholder="search 321 Vets"></input> */}
      {/* </div> */}

      {/* Dynamic category grid, full width, no columns */}
      {loading ? (
        <div>Loading categories...</div>
      ) : error && categories.length === 0 ? (
        <div>
          {" "}
          <span>Error loading categories.</span>
          <span>
            <a className="text-blue-500 hover:underline" href="/">
              Refresh
            </a>
          </span>
        </div>
      ) : (
        renderCategoryGrid()
      )}

      {/* Classifieds container - improved style */}
      <div
        className="classifieds"
        style={{
          background: "#f8fafc",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          padding: "2rem 1rem",
          margin: "2rem 0",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: 700,
            color: "#1e293b",
            marginBottom: "1.2rem",
            letterSpacing: "0.02em",
            textAlign: "center",
          }}
        >
          Classifieds
        </h2>
        <div
          className="text-content"
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 2fr",
            gap: "2rem",
          }}
        >
          <div
            // className="text-container"
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
              padding: "1rem 1.2rem",
              borderLeft: "4px solid #38bdf8",
            }}
          >
            <span
              className="head"
              style={{
                fontWeight: 600,
                color: "#0ea5e9",
                fontSize: "1.1rem",
                display: "block",
                marginBottom: "0.3em",
              }}
            >
              RELIEF VET AVAILABLE
            </span>
            <span
              style={{ color: "#334155", fontSize: "1rem", lineHeight: 1.5 }}
            >
              CA licensed vet available for shifts Wed - Fri starting in Feb
              2026 in near Rancho Palos Verdes. <br />
              <span style={{ fontWeight: 500 }}>Text 949-899-8387</span>
            </span>
          </div>

          <div
            // className="text-container"
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
              padding: "1rem 1.2rem",
              borderLeft: "4px solid #f59e42",
            }}
          >
            <span>
              <span
                className="head"
                style={{
                  fontWeight: 600,
                  color: "#f59e42",
                  fontSize: "1.1rem",
                  display: "block",
                  marginBottom: "0.3em",
                }}
              >
                Telehealth Vet Available Now
              </span>
              <span
                style={{ color: "#334155", fontSize: "1rem", lineHeight: 1.5 }}
              >
                25 years experience in dogs, cats, and exotics. Book Dr. Lisa on{" "}
                <b>www.VetRelief.pet</b>
              </span>{" "}
              <a
                className="see-more"
                href="https://www.vetrelief.pet/"
                target="_blank"
                style={{
                  color: "#0ea5e9",
                  fontWeight: 500,
                  textDecoration: "underline",
                  marginLeft: "0.2em",
                }}
              >
                www.VetRelief.pet
              </a>
            </span>
          </div>

          <div
            // className="text-container"
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
              padding: "1rem 1.2rem",
              borderLeft: "4px solid #22c55e",
            }}
          >
            <span>
              <span
                className="head"
                style={{
                  fontWeight: 600,
                  color: "#22c55e",
                  fontSize: "1.1rem",
                  display: "block",
                  marginBottom: "0.3em",
                }}
              >
                Seeking to Hire Vet Techs in Santa Ana, CA
              </span>
              <span style={{ color: "#334155", fontWeight: 500 }}>
                Call/Text 949-899-8387
              </span>
            </span>
          </div>
          <div
            // className="text-container"
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
              padding: "1rem 1.2rem",
              borderLeft: "4px solid #eab308",
            }}
          >
            <span>
              <span
                className="head"
                style={{
                  fontWeight: 600,
                  color: "#eab308",
                  fontSize: "1.1rem",
                  display: "block",
                  marginBottom: "0.3em",
                }}
              >
                Pet Sitting Available Southern California
              </span>
              <span style={{ color: "#334155", fontWeight: 500 }}>
                Call/Txt 949-899-8387
              </span>
            </span>
          </div>

          <div
            // className="text-container"
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
              padding: "1rem 1.2rem",
              borderLeft: "4px solid #6366f1",
            }}
          >
            <span>
              <span
                className="head"
                style={{
                  fontWeight: 600,
                  color: "#6366f1",
                  fontSize: "1.1rem",
                  display: "block",
                  marginBottom: "0.3em",
                }}
              >
                Seeking to Hire
              </span>
              <span style={{ color: "#334155" }}>
                Permanent Vet in Westwood, NJ, click{" "}
              </span>
              <a
                className="see-more "
                href="https://vetrelief.com/doctorlogin/?page=jobs_perm&sub=detail&id=113367"
                target="_blank"
                style={{
                  color: "#6366f1",
                  fontWeight: 500,
                  textDecoration: "underline",
                  marginLeft: "0.2em",
                }}
              >
                here
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className="column-2">
        <div className="job_listings">
          <h3>Jobs For Vets</h3>

          {/* displays job listings */}
          <div className="j_list">
            <h2>Browse relief, permanent, or virtual jobs</h2>

            {/* displays map */}
            <div className="map">
              <iframe
                className="google-maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6512742.904804467!2d-124.5938672237518!3d37.15150473373539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2stz!4v1740768040883!5m2!1sen!2stz/"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Section for displaying adverts */}
      <div className="adverts">
        <a href="https://www.vetrelief.pet/" target="_blank">
          <p id="probiotic-para">Advertisement</p>
          <div className="long-ad ad-image">
            <img src={virtualImage} alt="vitual image" />
          </div>
        </a>
      </div>
    </div>
  );
}

export default Listings;
